
import { create } from 'zustand';
import type { ClientActions } from './types';
import { getUserSubscriptions, pauseSubscription, resumeSubscription } from '@/services/edgeFunctionWrappers/subscriptionsManagementWrapper';
import { getUserGymId } from '@/utils/gymAuth';

export const useClientActionsStore = create<ClientActions>((set) => ({
  isLoading: false,
  
  pauseSubscription: async (clientId, startDate) => {
    set({ isLoading: true });
    try {
      const gymId = getUserGymId();
      if (!gymId) {
        console.error('[clientActionsStore] No gym_id available');
        set({ isLoading: false });
        return false;
      }

      // Get the latest active subscription via edge function
      const subscriptions = await getUserSubscriptions(clientId, 'active', gymId);
      
      if (!subscriptions || subscriptions.length === 0) {
        console.warn('[clientActionsStore] No active subscription found for client:', clientId);
        set({ isLoading: false });
        return false;
      }

      const subscriptionId = subscriptions[0].id;
      const isoDateOnly = new Date(startDate).toISOString().split("T")[0];

      // Pause via edge function wrapper
      const success = await pauseSubscription(subscriptionId, isoDateOnly, gymId);
      
      set({ isLoading: false });
      return success;
    } catch (error) {
      console.error('Error pausing subscription:', error);
      set({ isLoading: false });
      return false;
    }
  },

  resumeSubscription: async (clientId) => {
    set({ isLoading: true });
    try {
      const gymId = getUserGymId();
      if (!gymId) {
        console.error('[clientActionsStore] No gym_id available');
        set({ isLoading: false });
        return false;
      }

      // Get the latest paused subscription via edge function
      // Note: subscriptionsManagementWrapper doesn't filter by is_paused, so we fetch active and filter
      const allSubscriptions = await getUserSubscriptions(clientId, undefined, gymId);
      const pausedSubscriptions = allSubscriptions.filter((s: any) => s.is_paused === true);
      
      if (!pausedSubscriptions || pausedSubscriptions.length === 0) {
        console.warn('[clientActionsStore] No paused subscription found for client:', clientId);
        set({ isLoading: false });
        return false;
      }

      const subscriptionId = pausedSubscriptions[0].id;

      // Resume via edge function wrapper
      const success = await resumeSubscription(subscriptionId, gymId);
  
      set({ isLoading: false });
      return success;
    } catch (error) {
      console.error('Error resuming subscription:', error);
      set({ isLoading: false });
      return false;
    }
  }
}));
